import type { CSSProperties } from 'react';
import { cn } from '@/utils/cn';
import { LockGlyph } from './LockGlyph';

interface LockCircleProps {
  /** Circle diameter in px (even). */
  size: number;
  /** Padlock size in px (even). */
  glyphSize: number;
  /** Background + text colour + margins, e.g. "bg-primary-100 text-primary-600 mb-4". Never size. */
  className?: string;
}

/** Exact circle (explicit equal px sizes, flex-none) with the padlock geometrically centred. Decorative. */
export const LockCircle = ({ size, glyphSize, className }: LockCircleProps) => {
  const style: CSSProperties = {
    width: size,
    height: size,
    minWidth: size,
    minHeight: size,
    maxWidth: size,
    maxHeight: size,
    padding: 0,
    lineHeight: 0,
    fontSize: 0,
  };
  return (
    <div
      aria-hidden="true"
      style={style}
      className={cn(
        'box-border flex flex-none shrink-0 grow-0 aspect-square items-center justify-center overflow-hidden rounded-full',
        className
      )}
    >
      <LockGlyph size={glyphSize} />
    </div>
  );
};

export default LockCircle;
